import { NgModule } from '@angular/core';

import { MaterialModule } from '../../modules/material.module';
import { SharedModule } from '../../modules/shared.module';
import { SectionFooterComponent } from './section-footer.component';

@NgModule({
  imports: [
    SharedModule,
    MaterialModule
  ],
  declarations: [
    SectionFooterComponent
  ],
  exports: [
    SectionFooterComponent
  ]
})
export class SectionFooterModule {}
